import successPhone from './screens.png';
import mobilePhone from './antistress-coaching-course.png';
import logoHeader from './logo-ikk-classic.svg';

export const successPhoneImage = successPhone;
export const mobilePhoneImage = mobilePhone;
export const logoHeaderImage = logoHeader;
